var _defs, _path, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _circle2, _path8, _path9, _path10, _circle3, _path11, _path12, _path13, _path14, _path15, _rect, _rect2, _rect3, _rect4, _circle4, _circle5, _circle6, _path16, _path17, _circle7, _rect5, _rect6, _rect7, _rect8, _circle8, _circle9, _circle10, _path18, _rect9, _circle11, _path19, _rect10, _rect11, _rect12, _rect13, _circle12, _path20, _path21, _path22, _path23;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadDndDrawing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 335.059,
    height: 251.639,
    viewBox: "0 0 335.059 251.639",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f1f1f1;}.b{fill:#3c69e4;}.c{fill:#ffb7b7;}.d{fill:#2f2e41;}.e{fill:#ffb8b8;}.f{fill:#3f3d56;}.g{fill:#ccc;}.h{fill:#cbcbcb;}.i{fill:#e5e5e5;}.j{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M187.958,657.906l-.371-.685c4.968-2.687,11.151-6.031,14.38-11.518,3.183-5.409,3.255-12.754.186-19.169-2.611-5.46-7.408-10.351-13.872-14.145-1.275-.748-2.613-1.458-3.908-2.144a42.815,42.815,0,0,1-9.031-5.805c-3.674-3.35-6.454-8.973-4.382-13.981a9.293,9.293,0,0,1,8.055-5.636l.044.778a8.515,8.515,0,0,0-7.381,5.16c-1.925,4.654.716,9.935,4.189,13.1a42.246,42.246,0,0,0,8.871,5.693c1.3.69,2.648,1.4,3.937,2.16,6.6,3.873,11.5,8.881,14.18,14.481,3.179,6.646,3.1,14.271-.218,19.9C199.3,651.773,193.011,655.174,187.958,657.906Z",
    transform: "translate(-170.125 -406.485)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 6.817,
    cy: 3.311,
    rx: 6.817,
    ry: 3.311,
    transform: "translate(7.012 175.822)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 6.817,
    cy: 3.311,
    rx: 6.817,
    ry: 3.311,
    transform: "translate(12.465 197.636)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 6.817,
    cy: 3.311,
    rx: 6.817,
    ry: 3.311,
    transform: "translate(0 201.142)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 6.817,
    cy: 3.311,
    rx: 6.817,
    ry: 3.311,
    transform: "translate(19.477 219.45)"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 6.817,
    cy: 3.311,
    rx: 6.817,
    ry: 3.311,
    transform: "translate(33.11 219.45)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M390.4,534.836h16.089a56.273,56.273,0,0,0,0-19.183H390.4A34.517,34.517,0,0,1,390.4,534.836Z",
    transform: "translate(-304.514 -364.259)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M93.007,606.7h4.418l2.1-17.041H93.006Z",
    transform: "translate(-56.777 -359.964)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M260.04,756.7h8.7a5.545,5.545,0,0,1,5.545,5.544v.181H260.04Z",
    transform: "translate(-224.937 -511.409)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M222.891,604.656l4.29-1.056-2.031-17.05-6.332,1.559Z",
    transform: "translate(-133.581 -358.068)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M395.5,753.613l8.449-2.079h0a5.545,5.545,0,0,1,6.709,4.059l.043.175-13.833,3.4Z",
    transform: "translate(-307.633 -508.158)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M255.958,615.332l.918-4.7a86.616,86.616,0,0,1,13.814-36.226l3.946-19.656s-1.172-14.879,10.14-22.933l3.488-2.4,12.228.7,2.824,15.461,5.69,36.583s1.468.138,2.019,4.368a12.721,12.721,0,0,1,1.927,5.9,82.909,82.909,0,0,1,3.692,13.948l-.092,5.788-6.149,3.276L297.587,579.2l-9.167-20.263a162.462,162.462,0,0,1-11.17,26.507s-9.256,20.034-11.105,24.1l-2.019,6.661Z",
    transform: "translate(-222.445 -372.663)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 8.74,
    cy: 8.74,
    r: 8.74,
    transform: "translate(65.656 108.166)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 8.74,
    cy: 8.74,
    r: 8.74,
    transform: "translate(65.656 108.166)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M330,488.14l2.885-7.207a32.414,32.414,0,0,1,.357-20.21h0l.552-.455c4.809-3.96,9.029-3.239,12.946,1.605h0a10.829,10.829,0,0,0,2.192,2.066c1.727,1.212,4.468,7.8.849,11.656l-2.895,16.886C347.2,501.806,340.43,498.295,330,488.14Z",
    transform: "translate(-267.648 -328.888)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M375.529,548.422a3.2,3.2,0,0,0-4.126-2.655l-4.684-5.615-4.106,2.014L369.339,550a3.217,3.217,0,0,0,6.191-1.581Z",
    transform: "translate(-287.554 -379.215)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M351.925,509.406,340.2,491.828l3.391-12.746a4.825,4.825,0,0,1,8.681,4.212l-4.061,8.387,9.525,13.659Z",
    transform: "translate(-273.87 -340.273)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 8.385,
    cy: 8.385,
    r: 8.385,
    transform: "translate(50.433 98.222)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M296.464,406.212a8.385,8.385,0,0,0,12.948-4.4,8.385,8.385,0,1,1-16.356-3.439A8.382,8.382,0,0,0,296.464,406.212Z",
    transform: "translate(-244.879 -292.662)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M351.037,408.165c-1.464-2.621-2.024-3.715-3.911-5.309-1.669-1.409-3.722-1.823-5.378-.488a9.973,9.973,0,1,0,5.916,7.981C349.1,410.147,349.6,408.367,351.037,408.165Z",
    transform: "translate(-266.362 -294.606)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M308.453,771.779H189.645a.389.389,0,1,1,0-.779H308.453a.389.389,0,1,1,0,.779Z",
    transform: "translate(-181.726 -520.14)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M908.728,183.036h-.363V173.09a5.756,5.756,0,0,0-5.756-5.756H881.537a5.757,5.757,0,0,0-5.757,5.756v54.564a5.756,5.756,0,0,0,5.757,5.756h21.072a5.757,5.757,0,0,0,5.756-5.756V190.116h.363Z",
    transform: "translate(-600.825 -151.622)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M904.713,171.178h-2.75a2.042,2.042,0,0,1-1.891,2.814H888a2.042,2.042,0,0,1-1.891-2.814H883.54a4.3,4.3,0,0,0-4.3,4.3v54.484a4.3,4.3,0,0,0,4.3,4.3h21.173a4.3,4.3,0,0,0,4.3-4.3h0V175.477A4.3,4.3,0,0,0,904.713,171.178Z",
    transform: "translate(-602.938 -153.969)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 13.128,
    height: 1.04,
    transform: "translate(289.303 37.185)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 13.128,
    height: 1.04,
    transform: "translate(289.303 40.479)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 13.128,
    height: 1.04,
    transform: "translate(289.303 43.772)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 6.342,
    height: 6.342,
    transform: "translate(280.427 37.828)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 2.76,
    cy: 2.76,
    r: 2.76,
    transform: "translate(282.004 54.795)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 2.255,
    cy: 2.255,
    r: 2.255,
    transform: "translate(289.868 55.3)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 1.372,
    cy: 1.372,
    r: 1.372,
    transform: "translate(298.111 56.183)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M630.868,205.8H582.5a4.329,4.329,0,0,1-4.325-4.324V131.324A4.329,4.329,0,0,1,582.5,127h48.372a4.329,4.329,0,0,1,4.324,4.324v70.151A4.329,4.329,0,0,1,630.868,205.8Z",
    transform: "translate(-419.145 -127)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M635.508,207.365H586.965a1.335,1.335,0,0,1-1.333-1.333V135.416a1.335,1.335,0,0,1,1.333-1.333h48.543a1.335,1.335,0,0,1,1.333,1.333v70.616A1.335,1.335,0,0,1,635.508,207.365Z",
    transform: "translate(-423.7 -131.324)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "j",
    cx: 0.368,
    cy: 0.368,
    r: 0.368,
    transform: "translate(186.985 0.956)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 26.999,
    height: 1.551,
    transform: "translate(180.657 24.416)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 26.999,
    height: 1.551,
    transform: "translate(180.657 29.328)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 26.999,
    height: 1.551,
    transform: "translate(180.657 34.241)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 9.459,
    height: 9.459,
    transform: "translate(167.418 25.375)"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 3.758,
    cy: 3.758,
    r: 3.758,
    transform: "translate(174.701 46.867)"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 3.071,
    cy: 3.071,
    r: 3.071,
    transform: "translate(185.411 47.555)"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 1.868,
    cy: 1.868,
    r: 1.868,
    transform: "translate(196.636 48.757)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M719.753,345.953H577.032a3.928,3.928,0,0,0-3.928,3.928V429.4a3.928,3.928,0,0,0,3.928,3.928H719.753a3.928,3.928,0,0,0,3.928-3.928V349.881a3.928,3.928,0,0,0-3.928-3.928Z",
    transform: "translate(-416.052 -260.663)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "j",
    width: 140.044,
    height: 78.999,
    transform: "translate(162.319 92.232)"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "j",
    cx: 1.436,
    cy: 1.436,
    r: 1.436,
    transform: "translate(230.785 87.205)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M718.235,561.043H704.567v-.985a.2.2,0,0,0-.2-.2h-4.686a.2.2,0,0,0-.2.2v.985h-2.929v-.985a.2.2,0,0,0-.2-.2h-4.686a.2.2,0,0,0-.2.2h0v.985h-2.929v-.985a.2.2,0,0,0-.2-.2h-4.686a.2.2,0,0,0-.2.2h0v.985h-2.929v-.985a.2.2,0,0,0-.2-.2H675.67a.2.2,0,0,0-.2.2v.985h-2.929v-.985a.2.2,0,0,0-.2-.2h-4.686a.2.2,0,0,0-.2.2h0v.985h-2.929v-.985a.2.2,0,0,0-.2-.2H659.66a.2.2,0,0,0-.2.2h0v.985h-2.929v-.985a.2.2,0,0,0-.2-.2H619.634a.2.2,0,0,0-.2.2h0v.985H616.51v-.985a.2.2,0,0,0-.2-.2h-4.686a.2.2,0,0,0-.2.2h0v.985H608.5v-.985a.2.2,0,0,0-.2-.2h-4.686a.2.2,0,0,0-.2.2h0v.985H600.5v-.985a.2.2,0,0,0-.2-.2h-4.686a.2.2,0,0,0-.2.2h0v.985h-2.929v-.985a.2.2,0,0,0-.2-.2h-4.686a.2.2,0,0,0-.2.2h0v.985h-2.929v-.985a.2.2,0,0,0-.2-.2h-4.686a.2.2,0,0,0-.2.2v.985h-2.929v-.985a.2.2,0,0,0-.2-.2H571.6a.2.2,0,0,0-.2.2h0v.985h-8.981a4.686,4.686,0,0,0-4.686,4.686v2.119a4.686,4.686,0,0,0,4.686,4.686H718.235a4.686,4.686,0,0,0,4.686-4.686v-2.119A4.686,4.686,0,0,0,718.235,561.043Z",
    transform: "translate(-406.672 -391.248)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 45.287,
    height: 1.683,
    transform: "translate(218.271 99.754)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 45.287,
    height: 1.683,
    transform: "translate(218.271 105.083)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 45.287,
    height: 1.683,
    transform: "translate(218.271 110.412)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 10.26,
    height: 10.26,
    transform: "translate(203.91 100.794)"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 17.956,
    cy: 17.956,
    r: 17.956,
    transform: "translate(214.276 120.603)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M582.794,341.361h-3.765l6.663-13.54,6.7,13.527h-3.768v5.629h-5.827Z",
    transform: "translate(-353.477 -200.123)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M516.336,304.556a17.056,17.056,0,0,1,9.935-5.709l-1.72-1.445,1.839-.159,2.354,1.979-1.979,2.354-1.839.159,1.326-1.576a15.826,15.826,0,0,0,3.654,31.339l.046,1.282a17.111,17.111,0,0,1-13.616-28.224Z",
    transform: "translate(-378.888 -230.928)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M992.135,316.3A17.111,17.111,0,0,1,974.42,332.78l.046-1.282a15.826,15.826,0,0,0,3.653-31.339l1.326,1.576-1.839-.159-1.979-2.354,2.354-1.979,1.839.159-1.72,1.445A17.109,17.109,0,0,1,992.135,316.3Z",
    transform: "translate(-661.041 -230.928)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M707.36,591.779h-204.9a.39.39,0,0,1,0-.779h204.9a.39.39,0,0,1,0,.779Z",
    transform: "translate(-372.691 -410.256)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadDndDrawing);
export default __webpack_public_path__ + "static/media/UploadDNDDrawing.3473f4e7a7ff3017e3ac09a940bf9d8e.svg";
export { ForwardRef as ReactComponent };